import React from 'react';

const XOutlinedBlue = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
    >
        <path
            d="M14.09 0h2.716l-5.93 6.777L17.851 16H12.39l-4.28-5.592L3.217 16H.498L6.84 8.75.152 0h5.6l3.865 5.112zm-.953 14.377h1.503L4.933 1.538H3.317z"
            fill="#009FDF"
        />
    </svg>
);
export default XOutlinedBlue;
